import { ProfileLimit } from "domain-entities";

export const getIsDayViewEnabled = (
	userId: string,
	profileLimits?: ProfileLimit[]
): boolean => {
	if (!userId || !profileLimits) return false;
	
	const profileLimit = profileLimits.find(
		(item) => item.profileId === userId
	);
	return !!profileLimit?.planningBoardDayView;
}; 